<mat-form-field class="smp-chips full-width"
                [ngClass]="{ 'has-error': requiredMissing }">
    <mat-label *ngIf="label">{{ label | translate }} {{ required ? '*' : '' }}</mat-label>
    <mat-chip-list #chipListTO
                   class="full-width"
                   aria-label="email_to"
                   [disabled]="disabled">
        <mat-chip *ngFor="let email of emailAddresses; let i = index"
                  id="{{idPrefix}}{{idSuffix}}.chip_{{i}}"
                  [selectable]="false"
                  [removable]="!disabled"
                  (removed)="remove(i)"
                  [selected]="true"
                  color="{{ email.valid ? 'primary' : 'warn' }}">
            {{ email.value }}
            <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip>
        <input id="{{idPrefix}}{{idSuffix}}.input_text.new_chip"
               [matChipInputFor]="chipListTO"
               [matChipInputAddOnBlur]="true"
               (matChipInputTokenEnd)="add($event)">
    </mat-chip-list>
</mat-form-field>
